import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { HasWorkers } from "../abstracts/mixins/HasWorkers";


export const Task = (() => {

    return class Task extends CRUDEntity {

        constructor(id = null){

            Object.assign(Task.prototype, FormActions);
            Object.assign(Task.prototype, EntityModalForm);
            Object.assign(Task.prototype, HasAttachments);
            Object.assign(Task.prototype, HasWorkers);


            super();
            this.entityClass = 'task';
            this.id = id;
            this.urlRoot = '/tasker/task';
            this.sectionRootUrl = '/tasker';
        }
    }
})();
